/**
 * Array utility functions
 */

/**
 * Reorder an array by moving an item from one index to another.
 * Returns a new array (non-mutating).
 */
export function reorder<T>(list: T[], startIndex: number, endIndex: number): T[] {
  const result = [...list];
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);
  return result;
}
